import {reject} from 'lodash'
import {compliantStatusTypes, deliveryTypes} from 'app/constant'
import {order} from 'app/features/orders/models/EditOrderState'
import {
  actionType,
  calculateTotalPrice,
  mapToOrderEditDiscountModel,
  mapToViewOrderModel,
} from '../helper'

export const getEditOrder = () => async (dispatch: any, getState: any) => {
  const state: any = getState()
  const {deletedItems, order, newItems, viewOrder} = state.orders.orderEdit
  return {deletedItems, order, newItems, viewOrder}
}

export const resetEditOrderState = (state: any) => {
  state.isFetching = false
  state.newItems = []
  state.order = order
  state.isDirty = false
  state.deletedItems = []
  state.discounts = {}
  state.isValidateDiscount = false
  state.errors = []
  state.orderProcessErrors = []
  state.compliance = {
    errors: [],
    isComplianceChecked: false,
  }
}

export const setOrderSubtotal = (state: any, action: any) => {
  state.order.subtotalPrice = action.payload
  state.order.totalPrice = calculateTotalPrice(state.order)
}

export const setCompliantFetch = (state: any, action: any) => {
  state.isCompliantFetching = action.payload
  if (action.payload) {
    state.compliance.errors = []
  }
}

export const resetShippingTax = (state: any) => {
  state.order.shippingPrice = 0
  state.order.shippingRate = null
  state.order.shippingRateId = undefined
  state.order.totalTax = 0
  state.order.isCompliant = false
  state.isDirty = true
  state.compliance.isComplianceChecked = false
  state.orderProcessErrors = []
}

export const resetShippingTaxDiscount = (state: any) => {
  if(state.isDirtyShipping){
    resetShippingTax(state)
  }
  if(state.isDirtyDiscount) {
    state.isValidateDiscount = true
    state.order.totalDiscounts = 0
    state.order.discountCodeId = undefined
    state.order.wineClubDiscounts = 0
    state.order.wineClubDiscountCodeId = undefined
    state.order.totalPrice = calculateTotalPrice(state.order)
    state.orderProcessErrors = []
  }
}

export const setShippingCompliance = (state: any, action: any) => {
  const {totalTax, isCompliant, crv} = action.payload
  state.order.totalTax = totalTax
  state.order.isCompliant = isCompliant
  state.order.totalPrice = calculateTotalPrice(state.order)
  state.order.salesTax = parseFloat(totalTax) - parseFloat(crv)
  state.order.crv = parseFloat(crv)
  state.isDirty = true
}

export const setShippingComplianceResponse = (state: any, action: any) => {
  const {complianceStatus, errors} = action.payload
  if (complianceStatus === compliantStatusTypes.COMPLIANT) {
    state.compliance.errors = []
  } else {
    state.compliance.errors = errors
  }
  state.compliance.isComplianceChecked = true
  state.orderProcessErrors = []
}

export const changeShippingRate = (state: any, action: any) => {
  state.isDirty = true
  state.order.shippingRate = action.payload
  state.order.shippingPrice = parseFloat(action.payload.rate)
  state.order.shippingRateId = action.payload.id
  state.order.totalPrice = calculateTotalPrice(state.order)
}

export const setShippingPrice = (state: any, action: any) => {
  state.isDirty = true
  state.order.shippingRate = null
  state.order.shippingRateId = null
  state.order.shippingPrice = parseFloat(action.payload)
  state.order.totalPrice = calculateTotalPrice(state.order)
}

export const changeShippingAddress = (state: any, action: any) => {
  state.order = {
    ...state.order,
    shippingAddressId: action.payload.id,
    shippingAddress: action.payload,
    orderDeliveryMethod: deliveryTypes.ship,
  }
  state.isDirty = true
  resetShippingTax(state)
}

export const updateShippingAddress = (state: any, action: any) => {
  state.order = {
    ...state.order,
    shippingAddress: action.payload,
  }
}

export const changePaymentMethod = (state: any, action: any) => {
  const {address: billingAddress} = action.payload
  state.order = {
    ...state.order,
    paymentMethodId: action.payload.id,
    paymentMethod: action.payload,
    billingAddress,
    billingAddressId: billingAddress.id,
  }
  state.isDirty = true
}

export const setIsValidatingDiscount = (state: any, action: any) => {
  state.isValidatingDiscount = action.payload
}

export const setOrderNote = (state: any, action: any) => {
  state.order = {
    ...state.order,
    note: action.payload,
  }
}

export const setAddNewItems = (state: any, action: any) => {
  state.newItems = [...state.newItems, ...action.payload]
  resetShippingTaxDiscount(state)
}

export const setRemoveNewItem = (state: any, action: any) => {
  state.newItems = reject(state.newItems, {variantId: action.payload})
  resetShippingTaxDiscount(state)
}

export const setOrderDeliveryMethod = (state: any, action: any) => {
  state.order = {
    ...state.order,
    orderDeliveryMethod: action.payload,
  }
  state.order.totalTax = 0
  state.isDirty = true
  state.order.isCompliant = false
  if (action.payload === deliveryTypes.pickup) {
    state.order.shippingPrice = 0
    state.order.shippingRateId = null
    state.order.shippingRate = null
    state.order.shippingAddressId = null
    state.order.shippingAddress = null
  }
  // if (action.payload === deliveryTypes.ship && !state.order.shippingAddress) {
  //   state.order.shippingAddress =
  //     state.viewOrder.customer.shippingAddress ?? state.viewOrder.customer.billingAddress
  //   state.order.shippingAddressId =
  //     state.viewOrder.customer.shippingAddress?.id ?? state.viewOrder.customer.billingAddress?.id
  // }
  state.compliance.isComplianceChecked = false
  state.order.totalPrice = calculateTotalPrice(state.order)
}

export const setAllDiscounts = (state: any, {payload}: any) => {
  state.order.discountCodeId = payload.discountCodeId
  state.order.shippingDiscountCodeId = payload.shippingDiscountCodeId
  state.order.wineClubDiscountCodeId = payload.wineClubDiscountCodeId
  state.order.totalDiscounts = payload.totalDiscounts
  state.order.isFreeShipping = payload.isFreeShipping
  state.order.wineClubDiscounts = payload.wineClubDiscounts
  if (payload.isFreeShipping) {
    resetShippingTax(state)
  }
  state.discounts = payload
  state.isValidateDiscount = false
  state.order.totalPrice = calculateTotalPrice(state.order)
}

export const removePromoCode = (state: any) => {
  state.order.discountCodeId = null
  state.order.totalDiscounts = 0
  state.discounts.discountCodeId = null
  state.discounts.totalDiscounts = 0
  state.order.totalPrice = calculateTotalPrice(state.order)
}

export const removeShippingDiscount = (state: any) => {
  state.order.shippingDiscountCodeId = null
  state.discounts.shippingDiscountCodeId = null
  state.discounts.isFreeShipping = false
  state.discounts.freeShipCode = ''
  resetShippingTax(state)
}

export const setIsTaxRemoved = (state: any, action: any) => {
  state.order.isTaxRemoved = action.payload
}

export const setIsAutoDiscountRemoved = (state: any, action: any) => {
  state.order.isAutoDiscountRemoved = action.payload
}

export const setDeleteItems = (state: any, payload: any) => {
  switch (payload.type) {
    case actionType.add: {
      state.deletedItems.push(payload.data)
      resetShippingTaxDiscount(state)
      return {...state}
    }
    case actionType.remove: {
      state.deletedItems = reject(state.deletedItems, {variantId: payload.data})
      resetShippingTaxDiscount(state)
      return {...state}
    }
    case actionType.update: {
      const index = state.deletedItems.findIndex(
        ({variantId}: any) => variantId === payload.data.variantId
      )
      state.deletedItems[index] = payload.data
      resetShippingTaxDiscount(state)
      return {...state}
    }
    default: {
      state.deletedItems = [...state.deletedItems, ...payload]
      resetShippingTaxDiscount(state)
      return {...state}
    }
  }
}

export const setEditOrder = (state: any, action: any) => {
  const {order, ...rest} = action.payload
  state.order = rest
  setDiscounts(state, {payload: rest.discounts.nodes})
  state.viewOrder = mapToViewOrderModel(order)
  if (rest?.notes) {
    setOrderNotes(state, {payload: rest?.notes})
  }
}

export const setOrderNotes = (state: any, action: any) => {
  state.viewOrder.notes = action.payload
}

export const setDiscounts = (state: any, action: any) => {
  const discounts = mapToOrderEditDiscountModel(action.payload)
  setAllDiscounts(state, {payload: discounts})
  state.discounts = mapToOrderEditDiscountModel(action.payload)
}
